import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { EtiquetadoContextService } from "../../context/etiquetado-context.service";
import { EtiquetadoService } from "../../services/etiquetado.service";
import { Router } from "@angular/router";

@Component({
    selector: 'app-mantenimiento-confecciones',
    templateUrl: './mantenimiento-confecciones.component.html'
})
export class MantenimientoConfeccionesComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    public filtersVisible = true;
    public filtersForm: UntypedFormGroup;
    public disabled: Subject<boolean> = new Subject();
    public denominacionesList;
    public permitePallets;
    public disabledEtiquetador: Subject<boolean> = new Subject();

    public confeccionesCaja = [];
    public confeccionesPallet = [];

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showWarning: boolean;
    public toCloseSpinner = 0;

    public pestanaActiva = 1;
    public exportModal = 0;
    public fileType = '';

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public columnIdCajas: number;
    public orderByCajas: string;
    public columnIdPallets: number;
    public orderByPallets: string;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _router: Router,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _etiquetadoContext: EtiquetadoContextService,
        private readonly _dataProvider: DataProvider,
        private readonly _utilsService: UtilsService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            etiquetador: ['', Validators.required],
            denominacion: [{value:'', disabled: true}],
            desConfeccion: [''],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false'],
            activo: ['']
        });

        this._etiquetadoContext.mantenimientoConfeccionesFilters = null;

        this.checkWarnings(this.filtersForm.get('etiquetador').value);

        this.filtersForm.get('etiquetador').valueChanges
        .pipe(debounceTime(500))
        .pipe(distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)))
        .pipe(takeUntil(this.destroy$))
        .subscribe((etiquetador: any) => {
            if (etiquetador) {
                const filtersPallet = {
                    etiquetadorId: etiquetador.id,
                    denominacionId: null
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.checkEtqPaisDenominacionPermisoPallet(filtersPallet).toPromise().finally(() => {
                  this.checkCloseSpinner();
                }).then((resp) => {
                    this.permitePallets = resp;
                });

                const filters = {
                    etiquetadorId: etiquetador.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getAllDenominacionesEtiquetador(filters).toPromise().finally(() => {
                  this.checkCloseSpinner();
                }).then((resp) => {
                    this.denominacionesList = resp.lista;
                    if (this.denominacionesList.length === 1) {
                        this.filtersForm.get('denominacion').patchValue(this.denominacionesList[0]);
                        this.filtersForm.get('denominacion').disable();
                        this.disabled.next(true);
                    } else {
                        this.filtersForm.get('denominacion').enable();
                        this.filtersForm.get('denominacion').patchValue('');
                        this.disabled.next(false);
                    }
                });
            } else {
                this.denominacionesList = [];
                this.filtersForm.get('denominacion').disable();
                this.filtersForm.get('denominacion').patchValue('');
                this.disabled.next(true);
            }
          });

        this.filtersForm.get('denominacion').valueChanges
        .pipe(debounceTime(500))
        .pipe(distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)))
        .pipe(takeUntil(this.destroy$))
        .subscribe((denominacion: any) => {
            if (this.filtersForm.get('etiquetador').value) {
                if (denominacion) {
                    const filtersPallet = {
                        etiquetadorId: this.filtersForm.get('etiquetador').value.id,
                        denominacionId: denominacion.id
                    };
                    this._spinnerService.showSpinner();
                    this.toCloseSpinner += 1;
                    this._etiquetadoService.checkEtqPaisDenominacionPermisoPallet(filtersPallet).toPromise().finally(() => {
                      this.checkCloseSpinner();
                    }).then((resp) => {
                        this.permitePallets = resp;
                    });
                } else {
                    if (this.filtersForm.get('etiquetador').value) {}
                    const filtersPallet = {
                        etiquetadorId: this.filtersForm.get('etiquetador').value.id,
                        denominacionId: null
                    };
                    this._spinnerService.showSpinner();
                    this.toCloseSpinner += 1;
                    this._etiquetadoService.checkEtqPaisDenominacionPermisoPallet(filtersPallet).toPromise().finally(() => {
                      this.checkCloseSpinner();
                    }).then((resp) => {
                        this.permitePallets = resp;
                    });
                }
            }
          });


        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        if (this.etiquetadores && this.etiquetadores.length === 1) {
            this.getConfecciones();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get etiquetadores() {
        if (this._dataProvider.etiquetadores && this._dataProvider.etiquetadores.length === 1) {
            this.filtersForm.get('etiquetador').patchValue(this._dataProvider.etiquetadores[0]);
            this.filtersForm.get('etiquetador').disable({onlySelf: true, emitEvent: false});
        } else {
            this.filtersForm.get('etiquetador').enable({onlySelf: true, emitEvent: false});
            this.disabledEtiquetador.next(false);
        }
        return this._dataProvider.etiquetadores;
    }

    public get yesNo() {
        return this._dataProvider.yesNo;
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    private checkWarnings(etiquetador) {
        if (etiquetador && this.filtersForm.valid) {
            this.filtersVisible = false;
            this.showWarning = false;
            this.mensajes = [];
            this.getConfecciones();
        } else {
            this.filtersVisible = true;
            this.showWarning = true;
            this.mensajes.push({ class: 'warning', message: 'global.info.filterRequired' });
        }
    }

    public pageChange(page) {
        this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters.numPagina = this.currentPage = page - 1;
        this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters.numPagina = this.currentPage = page - 1;
        this.getConfecciones();
    }

    public itemsPerPageChange(items) {
        this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters.numPagina = this.currentPage = 0;
        this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters.tamPagina = this.itemsPerPage = items;
        this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters.numPagina = this.currentPage = 0;
        this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters.tamPagina = this.itemsPerPage = items;
        this.getConfecciones();
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').errors.includes('Invalid date')) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').errors.includes('Invalid date')) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return (this.filtersForm.get('etiquetador').value && this.filtersForm.get('etiquetador').enabled ||
            (this.filtersForm.get('denominacion').value && this.filtersForm.get('denominacion').enabled ) ||
            this.filtersForm.get('desConfeccion').value ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value ||
            this.filtersForm.get('activo').value) ? true : false;
    }

    public resetForm() {
        this.filtersForm.reset({
            etiquetador: this.filtersForm.get('etiquetador').disabled ? this.filtersForm.get('etiquetador').value : null,
            dateType: 'false'
        });
    }

    public filtrar() {
        this.validDates();
        if (this.filtersForm.invalid) {
            if (Object.keys(this.filtersForm.controls).some(key => this.filtersForm.get(key).hasError('required'))) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.required' });
            }
        } else {
            this.showError = false;
            this.mensajes = [];
            this.applyFilters();
        }
    }

    private applyFilters() {
        this.currentPage = 0;
        this._etiquetadoContext.mantenimientoConfeccionesFilters = {
            cajaFilters: {
                etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : null,
                denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : null,
                desConfeccion: this.filtersForm.get('desConfeccion').value ? this.filtersForm.get('desConfeccion').value : '',
                fechaInicio: this.filtersForm.get('fechaInicio').value ?
                    this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
                fechaFin: this.filtersForm.get('fechaFin').value ?
                    this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
                fechaActualizacion: this.filtersForm.get('dateType').value,
                activo: this.filtersForm.get('activo').value ? this.filtersForm.get('activo').value.value : '',
                confeccionMix: null,
                tipoConfeccionId: 1,
                numPagina: this.currentPage,
                tamPagina: this.itemsPerPage
            },
            palletFilters: {
                etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : null,
                denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : null,
                desConfeccion: this.filtersForm.get('desConfeccion').value ? this.filtersForm.get('desConfeccion').value : '',
                fechaInicio: this.filtersForm.get('fechaInicio').value ?
                    this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
                fechaFin: this.filtersForm.get('fechaFin').value ?
                    this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
                fechaActualizacion: this.filtersForm.get('dateType').value,
                activo: this.filtersForm.get('activo').value ? this.filtersForm.get('activo').value.value : '',
                confeccionMix: null,
                tipoConfeccionId: 2,
                numPagina: this.currentPage,
                tamPagina: this.itemsPerPage
            }
        };

        this._etiquetadoContext.confeccionesCajaFilters = {
            currentPage: this.currentPage,
            itemsPerPage: this._etiquetadoContext.confeccionesCajaFilters ?
                this._etiquetadoContext.confeccionesCajaFilters.itemsPerPage : this.itemsPerPage
        };

        this._etiquetadoContext.confeccionesPalletFilters = {
            currentPage: this.currentPage,
            itemsPerPage: this._etiquetadoContext.confeccionesPalletFilters ?
                this._etiquetadoContext.confeccionesPalletFilters.itemsPerPage : this.itemsPerPage
        };
        this.getConfecciones();
    }

    public getConfecciones() {
        if (this._etiquetadoContext.mantenimientoConfeccionesFilters) {
            this._filters = this._etiquetadoContext.mantenimientoConfeccionesFilters;
        } else {
            this.applyFilters();
        }

        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        if (this.pestanaActiva === 1) {
            this._etiquetadoService.getConfecciones(this._filters.cajaFilters).toPromise().finally(() => {
              this.checkCloseSpinner();
            }).then((resp) => {
                this.totalItems = resp.paginacionMeta.totalCount;
                this.confeccionesCaja = resp.lista;
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        } else if (this.pestanaActiva === 2) {
            this._etiquetadoService.getConfecciones(this._filters.palletFilters).toPromise().finally(() => {
              this.checkCloseSpinner();
            }).then((resp) => {
                this.totalItems = resp.paginacionMeta.totalCount;
                this.confeccionesPallet = resp.lista;
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        } else {
            this.confeccionesCaja = [];
            this.confeccionesPallet = [];
        }
    }

    public showConfeccionesCaja() {
        this.pestanaActiva = 1;
        if (this._etiquetadoContext.mantenimientoConfeccionesFilters) {
            this.saveConfeccionesPallet();
            this.confeccionesCaja = [];
            this.totalItems = 0;
            this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters.numPagina =
                this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters.numPagina =
                this.currentPage = this._etiquetadoContext.confeccionesCajaFilters ?
                    this._etiquetadoContext.confeccionesCajaFilters.currentPage : 0;

            this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters.tamPagina =
                this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters.tamPagina =
                this.itemsPerPage = this._etiquetadoContext.confeccionesCajaFilters ?
                    this._etiquetadoContext.confeccionesCajaFilters.itemsPerPage : this._DEFAULT_ITEMS_PER_PAGE;

            this.getConfecciones();
        }
    }

    public showConfeccionesPallet() {
        this.pestanaActiva = 2;
        if (this._etiquetadoContext.mantenimientoConfeccionesFilters) {
            this.saveConfeccionesCaja();
            this.confeccionesPallet = [];
            this.totalItems = 0;
            this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters.numPagina =
                this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters.numPagina =
                this.currentPage = this._etiquetadoContext.confeccionesPalletFilters ?
                    this._etiquetadoContext.confeccionesPalletFilters.currentPage : 0;

            this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters.tamPagina =
                this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters.tamPagina =
                this.itemsPerPage = this._etiquetadoContext.confeccionesPalletFilters ?
                    this._etiquetadoContext.confeccionesPalletFilters.itemsPerPage : this._DEFAULT_ITEMS_PER_PAGE;

            this.getConfecciones();
        }
    }

    private saveConfeccionesCaja() {
        this._etiquetadoContext.confeccionesCajaFilters = {
            currentPage: this.currentPage,
            itemsPerPage: this.itemsPerPage
        };
    }

    private saveConfeccionesPallet() {
        this._etiquetadoContext.confeccionesPalletFilters = {
            currentPage: this.currentPage,
            itemsPerPage: this.itemsPerPage
        };
    }

    public refresh(value) {
        if (value && this.filtersForm.get('etiquetador').value !== '') {
            this.getConfecciones();
        }
    }

    private checkCloseSpinner() {
      this.toCloseSpinner -= 1;
      if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
      }
    }

    public sort(obj) {
      if(this.pestanaActiva == 1) {
        this.columnIdCajas = obj.idColumn;
        if (this.confeccionesCaja && this.confeccionesCaja.length > 0) {
          if (this._etiquetadoContext.confeccionesCajaFilters) {
            if (!this.orderByCajas || this.orderByCajas.includes('DESC')) {
              this.orderByCajas = 'ASC' + obj.idColumn;
              this._filters.cajaFilters.orderItems = [
                {
                  orderProperty: obj.columnFilter,
                  orderByDescending: false
                }
              ];
            } else if (this.orderByCajas.includes('ASC')) {
              this.orderByCajas = 'DESC' + obj.idColumn;
              this._filters.cajaFilters.orderItems = [
                {
                  orderProperty: obj.columnFilter,
                  orderByDescending: true
                }
              ];
            }
            this.getConfecciones();
          }
        }
      } else{
        this.columnIdPallets = obj.idColumn;
        if (this.confeccionesPallet && this.confeccionesPallet.length > 0) {
          if (this._etiquetadoContext.confeccionesPalletFilters) {
            if (!this.orderByPallets || this.orderByPallets.includes('DESC')) {
              this.orderByPallets = 'ASC' + obj.idColumn;
              this._filters.palletFilters.orderItems = [
                {
                  orderProperty: obj.columnFilter,
                  orderByDescending: false
                }
              ];
            } else if (this.orderByPallets.includes('ASC')) {
              this.orderByPallets = 'DESC' + obj.idColumn;
              this._filters.palletFilters.orderItems = [
                {
                  orderProperty: obj.columnFilter,
                  orderByDescending: true
                }
              ];
            }
            this.getConfecciones();
          }
        }
      }
    }
    
    private downloadCsv(filters) {
      this._etiquetadoService.getRepConfeccionesCsv(filters).toPromise().finally(() => {
          this.checkCloseSpinner();
        }).then((resp) => {
          const downloadLink = document.createElement('a');
          downloadLink.href = 'data:text/csv;base64,' + resp.base64Archivo;
          downloadLink.download = resp.nombreArchivo;
          downloadLink.click();
        },
        (error) => {
          this.showError = true;
          this.mensajes.push({ class: 'error', message: 'global.error.file' });
        }
      );
    }

    private downloadPdf(filters) {
      this._etiquetadoService.getRepConfeccionesPdfOrExcel(filters).toPromise().finally(() => {
        this.checkCloseSpinner();
        }).then((resp) => {
          const downloadLink = document.createElement('a');
          downloadLink.href = 'data:application/pdf;base64,' + resp.base64Archivo;
          downloadLink.download = resp.nombreArchivo;
          downloadLink.click();
        },
        (error) => {
          this.showError = true;
          this.mensajes.push({ class: 'error', message: 'global.error.file' });
        }
      );
    }

  private getReportsFilters(type: string, detail: number) {
    if ((this.confeccionesCaja && this.confeccionesCaja.length > 0) || 
    (this.confeccionesPallet && this.confeccionesPallet.length > 0)) {
      let filters;
      if (this._etiquetadoContext.mantenimientoConfeccionesFilters) {
        if (this.pestanaActiva === 1) {
          if (this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters) {
            filters = {...this._etiquetadoContext.mantenimientoConfeccionesFilters.cajaFilters};
          }
        } else {
          if (this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters) {
            filters = {...this._etiquetadoContext.mantenimientoConfeccionesFilters.palletFilters};
          }
        }
        filters.tamPagina = 0;
        filters.tipoArchivo = type;
        filters.mostrarDetalle = detail === 1 ? false : true;
      }
      return filters;
    } else {
      this.mensajes.push({ class: 'error', message: 'global.error.exportNoData' });
    }
  }

  private exportPdfOrCsv(filters) {

    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;

    switch (this.fileType) {
      case 'Pdf':
        this.downloadPdf(filters);
        break;
      case 'Csv':
        this.downloadCsv(filters);
        break;
    }
  }    
  

  public export(type) {
      let filters = this.getReportsFilters(this.fileType, type);
      this.exportPdfOrCsv(filters);
      this.exportModal = 0;
  }

  public openDocHelp(type: number) {
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    const doc = this.permitePallets ? 'Labeling_Packaging_Pallet.pdf' : 'Labeling_Packaging_Box.pdf';
    this._etiquetadoService.getDocHelp(doc).toPromise().finally(() => {
        this.checkCloseSpinner();
    }).then((resp) => {
        localStorage.setItem('base64', resp.base64Archivo);
        const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
        window.open(url, '_blank');
    });
  }
}


